import agencyConfig from '@le2/jfd-kcso'

export default agencyConfig
